module.exports = __webpack_public_path__ + "img/blmlogo.77d095c1.jpg";